import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import './Legalpage.css';

/*
  Shared layout for Terms and Privacy.
  A section's "blocks": a string = paragraph, an array = bullet list.
  Sections with no blocks are hidden (use this for policies not decided yet).
*/
const LegalPage = ({ eyebrow, title, updated, intro, summary = [], sections = [], related }) => {
  const EMAIL = process.env.REACT_APP_EMAIL;
  const PHONE = process.env.REACT_APP_MOBILE_NUMBER1;
  const visible = sections.filter((s) => s.blocks && s.blocks.length > 0);

  return (
    <article className="rmlegal">
      <div className="rmlegal-inner">
        <header className="rmlegal-head">
          <span className="rmlegal-eyebrow">{eyebrow}</span>
          <h1 className="rmlegal-title">{title}</h1>
          <p className="rmlegal-updated">Last updated: {updated}</p>
          {intro && <p className="rmlegal-intro">{intro}</p>}
        </header>

        {summary.length > 0 && (
          <section className="rmlegal-summary" aria-labelledby="rmlegal-summary-title">
            <h2 id="rmlegal-summary-title">In short</h2>
            <ul>
              {summary.map((line) => (
                <li key={line}>{line}</li>
              ))}
            </ul>
          </section>
        )}

        <div className="rmlegal-layout">
          <nav className="rmlegal-toc" aria-label="On this page">
            <p className="rmlegal-toc-title">On this page</p>
            <ol>
              {visible.map((s) => (
                <li key={s.id}>
                  <a href={`#${s.id}`}>{s.title}</a>
                </li>
              ))}
            </ol>
          </nav>

          <div className="rmlegal-body">
            {visible.map((s, i) => (
              <section key={s.id} id={s.id} className="rmlegal-section">
                <h2 className="rmlegal-h2">
                  <span className="rmlegal-num">{i + 1}</span>
                  {s.title}
                </h2>
                {s.blocks.map((block, j) =>
                  Array.isArray(block) ? (
                    <ul key={j} className="rmlegal-list">
                      {block.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  ) : (
                    <p key={j}>{block}</p>
                  )
                )}
              </section>
            ))}

            <section className="rmlegal-contact" aria-labelledby="rmlegal-contact-title">
              <h2 id="rmlegal-contact-title">Questions?</h2>
              <p>Contact us and we’ll get back to you.</p>
              <div className="rmlegal-contact-links">
                {EMAIL && (
                  <a href={`mailto:${EMAIL}`}>
                    <FontAwesomeIcon icon={faEnvelope} /> {EMAIL}
                  </a>
                )}
                {PHONE && (
                  <a
                    href={`https://api.whatsapp.com/send/?phone=${PHONE}&type=phone_number&app_absent=0`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faWhatsapp} /> WhatsApp
                  </a>
                )}
              </div>
            </section>

            {related && (
              <Link to={related.to} className="rmlegal-related">
                {related.label}
                <FontAwesomeIcon icon={faArrowRight} />
              </Link>
            )}
          </div>
        </div>
      </div>
    </article>
  );
};

export default LegalPage;